import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Landing from "../components/Landing";
import Home from "../components/Home";
import History from "../components/History";
import Restaurant from "../components/Restaurant";
import VueQrCodeReader from "vue-qrcode-reader";
import Visitor from "../components/Visitor";
import NailArt from "../components/NailArt";
import Place from "../components/Place";
import Order from "../components/Order";
import VModal from 'vue-js-modal'
import * as VueGoogleMaps from "vue2-google-maps";
import Shop from "../components/Shop";
import Product from "../components/Product";
import Booking from "../components/Booking";
import Menus from "../components/Menus";
import MyBooking from "../components/MyBooking";
import BookingTnC from "../components/BookingTnC";
import BookingPrivacy from "../components/BookingPrivacy";
import BookingTableView from "../components/BookingTableView.vue";

import PlaceOrder from "../components/PlaceOrder.vue";
import ErrorView from "../components/ErrorView.vue";
import PointRegister from "../components/PointRegister.vue";
import CollaboOrder from "../components/CollaboOrder.vue";

Vue.use(VModal, { dialog: true, width:'90%' })

Vue.use(Router)
Vue.use(VueQrCodeReader);

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyA6vMDmF0Dk73mg9ZmTxe3tSlnlhO2RPOk",
    libraries: "places" // necessary for places input
  }
});
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Home
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path:'/restaurant/:id/:type',
      name: 'Restaurant',
      component: Restaurant
    },
    {
      path:'/hotel/:permalink/order',
      name: 'OrderSelector',
      component: PlaceOrder
    },
    {
      path:'/colab/:permalink/:partnerlink/order',
      name: 'PartnerSelector',
      component: CollaboOrder
    },
    {
      path:'/preorder/:id/:type/:orderType/:orderId',
      name: 'Restaurant',
      component: Restaurant
    },
    {
      path:'/place/:id',
      name: 'Place',
      component: Place
    },
    {
      path:'/menus/:id',
      name: 'Menus',
      component: Menus
    },
    {
      path: '/booking/:id',
      name: 'Booking',
      component: Booking
    },
    {
      path: '/reservation',
      name: 'Reservation',
      component: Booking
    },
    {
      path: '/elements/reservation-form',
      name: 'Reservation',
      component: Booking
    },
    {
      path: '/table-booking/:id',
      name: 'TableBooking',
      component: BookingTableView
    },
    {
      path: '/mybooking/:id',
      name: 'MyBooking',
      component: MyBooking
    },
    {
      path:'/order/:id/:type',
      name: 'Restaurant',
      component: Restaurant
    },
    {
      path:'/restaurant',
      name: 'Restaurant',
      component: Restaurant
    },
    {
      path:'/shop/:id',
      name: 'Shop',
      component: Shop
    },
    {
      path:'/history',
      name: 'History',
      component: History
    },
    {
      path:'/visitor/:id',
      name: 'Visitor',
      component: Visitor
    },
    {
      path:'/nailart/:id',
      name:'NailArt',
      component: NailArt
    },
    {
      path:'/myorder',
      name:'Order',
      component: Order,
    },
    {
      path:'/product/:id/:title',
      name: 'Product',
      component: Product
    },
    {
      path:'/tnc/booking',
      name: 'Booking Service Terms and Conditions',
      component: BookingTnC
    },
    {
      path:'/privacy/booking',
      name: 'Booking Privacy',
      component: BookingPrivacy
    },
    {
      path:'/error-view',
      name: 'ErrorView',
      component:ErrorView
    },
    {
      path:'/loyalty/register',
      name:'Loyalty Register',
      component: PointRegister
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js